import React, { Component } from "react";
import { Button, ControlLabel, Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import uniqueId       from 'lodash/uniqueId';
import LoaderButton                  from "../../components/LoaderButton";
import { invokeSaveBlockNameToProgram } from '../../utils/AwsInvoke';
import "../../css/modal/ModalChangeBlockName.css";
import "../../css/modal/ModalBasics.css";

const tmp_arr = ["Foam Roll","Correctives","Prep","S.L.A.T.E. (Speed. Landing. Acceleration. Tempo. Explosion)","Strength","ESD"];
var block_id;
var block_index;
var block_name;

export default class ModalChangeBlockName extends Component {

    constructor(props) {
        super(props);

        var block_name = this.props.block_name
        if(this.props.block_name === null) block_name = "";

        this.state = {
            content: block_name,
            program_id: null,
            error_msg: ""
        };
    }


    componentDidMount() {
        block_id    = this.props.block_id;
        block_index = this.props.block_index;
        block_name  = this.props.block_name;
    }

    handleEditBlockName (name) { //(block_index, name) {
        this.setState({
            content: name
        }, function() {
            this.handleSubmit();
        })
    }

    handleSubmit = async event => {
        var custom_name = this.state.content;

        if(custom_name === "") {
            alert("Please Select or Add a Block Name.")
            return;
        }

        const results = await invokeSaveBlockNameToProgram(block_id, custom_name);

        if(results) {
            this.props.handleEditBlockName(block_index, custom_name);

            // Close Modal //
            this.props.onHide();
        } else
            this.setState({
                error_msg: "Ooops, looks like there was an error. Try again."
            })
    }

    handleCustomChange(event) {
        var name = event.target.value;
        this.setState({
            content: name
        })

    }
    renderBlockList () {
        var list    = tmp_arr.map(name => {
                        return <ListGroupItem
                                  key={uniqueId()}
                                  className = "editBlockNameListGroupItem"
                                  onClick={() => this.handleEditBlockName(name)}//(block_index, name)}
                                  >
                                { name }
                                </ListGroupItem>
                        }
                    )
        return <ListGroup>
                    { list }
                </ListGroup>
    }

    render() {
        return (
            <Modal
                show      = {this.props.show}
                onHide    = {this.props.onHide}
                className = ""
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title" className="fontSize26px">Add/Edit Block Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div>
                      <div className="formLabelBody">Select a Block Name</div>
                          { this.renderBlockList() }
                          <div className="formLabelBody orBlockName">-- OR --</div>
                          <div className="formLabelBody">Add a Custom Block Name</div>
                          <input type="text"
                                 placeholder = "Block Name"
                                 value     = {this.state.content}
                                 onChange  = {this.handleCustomChange.bind(this)}
                                 className = "input-lg blockNameField" />

                  </div>
                  { this.state.error_msg }
                  <br/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    { /*}<Button className="modalButtonOk" bsStyle="primary" onClick={() => this.handleCloseWin("delete")}>Ok</Button>*/ }
                    <LoaderButton
                        bsSize    = "large"
                        //disabled  = {!this.validateForm()}
                        //type      = "submit"
                        btncolor  = "#09c141"
                        height    = {38}
                        width     = {120}
                        isLoading = {this.state.isLoading}
                        text        = "Submit"
                        loadingText = "" //"Deleting program…"
                        onClick     = {() => this.handleSubmit()}
                      />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalChangeBlockName.js